import React from 'react';
import EventCategoryLayout from '../../components/EventCategoryLayout';

const SocialEvents = () => {
  return <EventCategoryLayout categoryId="social" />;
};

export default SocialEvents;
